import React, { useContext, useMemo, useState } from 'react';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { getTodayDateRange } from '@common/helpers/getTodayDateRange';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { useDataFetch } from '@common/hooks/dataFetch';
import SmartTable from '@common/components/smartTable';
import Loader from '@common/components/loader';
import { PreferencesContext } from '@common/contexts/preferences';
import { descSort } from '@common/helpers/declarative/sortings';
import { getVirtualResultGamesFilters } from '@common/helpers/requests/virtualSports';
import { virtualsRowSportIds } from '@common/constants/virtuals';

import { standartColumnConfig } from './columnConfig/standartColumnConfig';
import { rowColumnConfig } from './columnConfig/rowColumnConfig';
import Filters from './components/filters';

import './style.scss';

const VirtualsResults = () => {
  const [selectedSport, setSelectedSport] = useState(null);
  const [dateFilter, setDateFilter] = useState(getTodayDateRange());
  const [{ lang }] = useContext(PreferencesContext);
  const [startDate, endDate] = dateFilter;

  const [data, isLoading] = useDataFetch(() => (selectedSport && startDate && endDate) && (
    swarmRequest(getVirtualResultGamesFilters(startDate, endDate, selectedSport), 'get_result_games')
  ), [startDate, endDate, selectedSport, lang]);

  const gamesList = useMemo(() => data?.games?.game?.sort(descSort('date')) || [], [data]);

  const columnConfig = virtualsRowSportIds.has(selectedSport?.id)
    ? rowColumnConfig()
    : standartColumnConfig();

  if (!selectedSport && isLoading) {
    return <div className="virtuals-loader"><Loader /></div>;
  }

  return (
    <div className="virtuals-results-wrapper">
      <Filters
        dateFilter={dateFilter}
        setDateFilter={setDateFilter}
        selectedSport={selectedSport}
        setSelectedSport={setSelectedSport}
      />
      <div className="virtuals-selected-sport">
        <i className={`sport-icon sport-icon-${selectedSport?.alias}`} />
        <span>{selectedSport?.value}</span>
      </div>
      <div className="virtuals-results-table-wrapper">
        <SmartTable data={gamesList} columnConfig={columnConfig} hasPagination />
      </div>
    </div>
  );
};

export default asyncWrapper(VirtualsResults);
